import { render, staticRenderFns } from "./peter-lauer.vue?vue&type=template&id=f5fe546a&scoped=true"
import script from "./peter-lauer.vue?vue&type=script&lang=js"
export * from "./peter-lauer.vue?vue&type=script&lang=js"
import style0 from "./peter-lauer.vue?vue&type=style&index=0&id=f5fe546a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fe546a",
  null
  
)

export default component.exports